<template>
  <div class="overflow-auto overflow-x-hidden" style="height: 100vh">
    <div class="mobile-status-padding"></div>
    <!-- Home Header -->
    <div class="flex justify-between items-center pt-6 px-6">
      <div class="relative flex whitespace-nowrap">
        <div
          class="relative flex items-center gap-8 origin-left scale-[0.8] -mr-24"
        >
          <div class="absolute -right-2 h-full top-0">
            <ImgComponent
              src="/images/all/helloBadgeForm.svg"
              class="h-full"
              alt=""
            />
          </div>
          <div class="relative bg-[#c1c1c1] p-2 text-white rounded-full">
            <div class="relative bg-black px-4 py-3 text-white rounded-full">
              <div class="overflow-hidden max-w-[65vw] flex items-center gap-1">
                <div class="truncate w-full">
                  {{ greetingMessage }}
                  {{
                    $stores?.user?.state?.current?.firstName ||
                    'Cher utilisateur'
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="block relative cursor-pointer"
            @click="navigateToNotifications"
          >
            <div class="ripple min-w-6 w-6 h-6 relative ml-auto">
              <ColorImg
                src="/images/icons/notification-outline.svg"
                class="bg-white w-full h-full"
                alt="Notifications"
              />
              <!-- Unread badge -->
              <div
                v-if="unreadNotificationsCount > 0"
                class="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white text-[10px] font-bold"
              >
                {{
                  unreadNotificationsCount > 9 ? '9+' : unreadNotificationsCount
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-4 justify-end ml-auto pr-2">
        <div
          class="ripple min-w-8 w-8 h-8 relative flex items-center justify-center"
          @click="navigateToWallet"
        >
          <ColorImg
            src="/images/icons/wallet-outline.svg"
            class="w-6 h-6 bg-secondary"
            alt="Solde"
          />
        </div>
        <router-link class="min-w-8 w-8 h-8 relative" to="/profile">
          <ColorImg
            src="/images/icons/user.svg"
            class="w-full h-full bg-secondary"
            alt=""
          />
        </router-link>
      </div>
    </div>

    <!-- Search Component -->
    <SearchFilter />
    <div class="py-1"></div>

    <!-- Publicités -->
    <div class="relative z-[1]">
      <Publicities />
    </div>

    <!-- Categories -->
    <div class="" id="categoriesList" @click="saveCategoriesClick">
      <div class="text-lg font-bold title-color px-6">Categories</div>
      <CategoriesList @categoryClicked="handleCategoryClicked" />
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Près de chez vous -->
    <div class=" ">
      <div class="text-lg font-bold title-color px-6">Près de chez vous</div>
      <DishesListHz
        type="near"
        :dishes="nearbyDishes"
        :loading="nearbyLoading"
        @refresh="
          () => {
            constants.EVENTS.HOME.NEARBY_LOAD &&
              bus.emit(constants.EVENTS.HOME.NEARBY_LOAD);
          }
        "
      />
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Nos Meilleurs Deals -->
    <div class="relative z-[1]">
      <div class="flex justify-between items-end px-6">
        <div class="text-lg font-bold title-color px-">Nos Meilleurs Deals</div>
        <router-link
          class="ripple text-primary font-bold text-lg relative"
          to="deals#deals"
        >
          Voir tout
        </router-link>
      </div>
      <TopDeals />
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Nos recommandations -->
    <div>
      <div class="px-6 text-lg font-bold title-color mb-4">
        Nos recommandations
      </div>
      <DishesListHz
        type="recommendations"
        :dishes="recommendedDishes"
        :loading="recommendedLoading"
        @refresh="
          () => {
            constants.EVENTS.HOME.RECOMMENDED_LOAD &&
              bus.emit(constants.EVENTS.HOME.RECOMMENDED_LOAD);
          }
        "
        v-if="showAll"
      />
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Nos Meilleurs Coupons -->
    <div class="relative z-[1]">
      <div class="flex justify-between items-end px-6">
        <div class="text-lg font-bold title-color px-">
          Nos Meilleurs Coupons
        </div>
        <router-link
          class="ripple text-primary font-bold text-lg relative"
          to="deals#coupons"
        >
          Voir tout
        </router-link>
      </div>
      <TopCouponsListHz v-if="showAll" />
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Restaurants à la une (Sponsorships) -->
    <div class=" ">
      <div class="text-lg font-bold title-color px-6 mb-4">
        Restaurants à la une
      </div>
      <SponsorshipCarousel v-if="showAll" />
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Restaurants populaires -->
    <div class=" ">
      <div class="text-lg font-bold title-color px-6">
        Restaurants populaires
      </div>
      <div class="mt-2">
        <RestaurantListHz
          v-if="showAll"
          :restaurants="popularRestaurants"
          :loading="popularRestaurantsLoading"
          :limit="10"
          type="popular"
          empty-title="Aucun restaurant populaire"
          empty-description="Les restaurants les plus appréciés s'afficheront ici très bientôt."
          :refresh-event="constants.EVENTS.HOME.POPULAR_RESTAURANTS_LOAD"
        />
      </div>
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Nouveau sur rapidoo -->
    <div class=" ">
      <div class="flex justify-between items-end px-6">
        <div class="text-lg font-bold title-color px-">Nouveau sur rapidoo</div>
      </div>
      <div class="mt-2">
        <RestaurantListHz
          v-if="showAll"
          :restaurants="newRestaurants"
          :loading="newRestaurantsLoading"
          :limit="10"
          type="new"
          empty-title="Rien de nouveau pour l'instant"
          empty-description="Nous ajoutons régulièrement de nouvelles pépites. Revenez plus tard !"
          :refresh-event="constants.EVENTS.HOME.NEW_RESTAURANTS_LOAD"
        />
      </div>
    </div>

    <div class="py-4"></div>
    <div class="py-1.5 bg-[#F4F4F5]"></div>
    <div class="py-4"></div>

    <!-- Tous nos restaurants -->
    <div class=" ">
      <div class="flex justify-between items-end px-6 mb-4">
        <div class="text-lg font-bold title-color px-">
          Tous nos restaurants
        </div>
      </div>
      <div class="w-full py-12 px-6 -mt-12 -mb-8">
        <RestaurantList
          :restaurants="allRestaurants"
          :loading="allRestaurantsLoading"
          :limit="0"
          v-if="showAll"
        />
      </div>
    </div>

    <div class="py-32"></div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { bus } from '@core/events/eventSystem';

// Constants
import constants from '@core/utils/constants';

// Components
import SearchFilter from '../components/SearchFilter.vue';
import CategoriesList from '../components/CategoriesList.vue';
import DishesListHz from '../components/DishesListHz.vue';
import TopDeals from '../components/TopDeals.vue';
import TopCouponsListHz from '../components/TopCouponsListHz.vue';
import TopRestaurantsListHz from '../components/TopRestaurantsListHz.vue';
import NewRestaurantsListHz from '../components/NewRestaurantsListHz.vue';
import NearRestaurantListHz from '../components/NearRestaurantListHz.vue';
import RestaurantList from '../components/RestaurantList.vue';
import RestaurantListHz from '../components/RestaurantListHz.vue';
import Publicities from '../components/Publicities.vue';
import SponsorshipCarousel from '../components/SponsorshipCarousel.global.vue';

const router = useRouter();
const showAll = ref(false);
let categoryOnboardingTimeoutId = 0;

// Computed properties
const greetingMessage = computed(() => {
  const hour = new Date().getHours();
  return hour >= 12 ? 'Bonsoir' : 'Bonjour';
});

// Unread notifications count from inbox store
const unreadNotificationsCount = computed(() => {
  return window.$stores?.inbox?.unreadCount || 0;
});

// Restaurant data computed properties
const popularRestaurants = computed(() => {
  return window.$stores?.home?.popularRestaurants || [];
});

const popularRestaurantsLoading = computed(() => {
  return window.$stores?.home?.state?.popularRestaurants?.loading || false;
});

const newRestaurants = computed(() => {
  return window.$stores?.home?.newRestaurants || [];
});

const newRestaurantsLoading = computed(() => {
  return window.$stores?.home?.state?.newRestaurants?.loading || false;
});

const allRestaurants = computed(() => {
  return window.$stores?.home?.allRestaurants || [];
});

const allRestaurantsLoading = computed(() => {
  return window.$stores?.home?.state?.allRestaurants?.loading || false;
});

const nearbyDishes = computed(() => {
  return window?.$stores?.home?.state?.nearby?.dishes || [];
});

const nearbyLoading = computed(() => {
  return window.$stores?.home?.state?.nearby?.loading || false;
});

const recommendedDishes = computed(() => {
  return window.$stores?.home?.state?.recommended?.dishes || [];
});

const recommendedLoading = computed(() => {
  return window.$stores?.home?.state?.recommended?.loading || false;
});

// Load all home data on mount
function homeLoadEvents() {
  console.log('[HomePage] homeLoadEvents - Starting to load all home data');

  // Emit all load events to fetch home data
  const homeEvents = constants.EVENTS.HOME;

  // Load nearby dishes
  if (homeEvents.RECOMMENDED_LOAD) {
    console.log(
      '[HomePage] Emitting RECOMMENDED_LOAD event:',
      homeEvents.RECOMMENDED_LOAD
    );
    bus.emit(homeEvents.RECOMMENDED_LOAD);
  }

  // Load nearby dishes
  if (homeEvents.NEARBY_LOAD) {
    console.log(
      '[HomePage] Emitting NEARBY_LOAD event:',
      homeEvents.NEARBY_LOAD
    );
    bus.emit(homeEvents.NEARBY_LOAD);
  }

  // Load categories
  if (homeEvents.CATEGORIES_LOAD) {
    console.log(
      '[HomePage] Emitting CATEGORIES_LOAD event:',
      homeEvents.CATEGORIES_LOAD
    );
    bus.emit(homeEvents.CATEGORIES_LOAD);
  }

  // Load ads/publicities
  if (homeEvents.ADS_LOAD) {
    console.log('[HomePage] Emitting ADS_LOAD event:', homeEvents.ADS_LOAD);
    bus.emit(homeEvents.ADS_LOAD);
  }

  // Load coupons
  if (homeEvents.COUPONS_LOAD) {
    console.log(
      '[HomePage] Emitting COUPONS_LOAD event:',
      homeEvents.COUPONS_LOAD
    );
    bus.emit(homeEvents.COUPONS_LOAD);
  }

  // Load popular restaurants
  if (homeEvents.POPULAR_RESTAURANTS_LOAD) {
    console.log(
      '[HomePage] Emitting POPULAR_RESTAURANTS_LOAD event:',
      homeEvents.POPULAR_RESTAURANTS_LOAD
    );
    bus.emit(homeEvents.POPULAR_RESTAURANTS_LOAD);
  }

  // Load new restaurants
  if (homeEvents.NEW_RESTAURANTS_LOAD) {
    console.log(
      '[HomePage] Emitting NEW_RESTAURANTS_LOAD event:',
      homeEvents.NEW_RESTAURANTS_LOAD
    );
    bus.emit(homeEvents.NEW_RESTAURANTS_LOAD);
  }

  // Load sponsorships
  if (homeEvents.SPONSORSHIPS_LOAD) {
    console.log(
      '[HomePage] Emitting SPONSORSHIPS_LOAD event:',
      homeEvents.SPONSORSHIPS_LOAD
    );
    bus.emit(homeEvents.SPONSORSHIPS_LOAD);
  }

  // Load all restaurants (for the bottom section)
  if (homeEvents.ALL_RESTAURANTS_LOAD) {
    bus.emit(homeEvents.ALL_RESTAURANTS_LOAD);
  }

  console.log('[HomePage] homeLoadEvents - All events emitted');
}

// Methods
function savePageShowMarker() {
  if (window.homeOnceShown) window.homeTwiceShown = true;
  window.homeOnceShown = true;
}

function tryCategoriesOnboarding() {
  if (!window.homeTwiceShown) return;
  const categoriesOnceClicked = localStorage.getItem('categoriesOnceClicked');
  if (categoriesOnceClicked) return;
  categoryOnboardingTimeoutId = setTimeout(() => {
    bus.emit('categories:onboarding_requested');
  }, 3000);
}

function saveCategoriesClick() {
  localStorage.setItem(
    'categoriesOnceClicked',
    JSON.stringify({ clicked: true })
  );
}

// Navigation handlers
function navigateToInbox() {
  bus.emit('bottom_nav:navigation_required', { id: 'inbox' });
}

function navigateToNotifications() {
  router.push('/inbox');
}

function navigateToWallet() {
  if (!window.$stores?.user?.state?.isLoggedIn) {
    router.push('/login');
    return;
  }
  bus.emit(constants.EVENTS.WALLET.MODAL_OPEN);
}

function navigateToDeals() {
  bus.emit('bottom_nav:navigation_required', { id: 'deals' });
}

function navigateToCoupons() {
  localStorage.setItem('directshowcoupons', JSON.stringify(true));
  bus.emit('bottom_nav:navigation_required', { id: 'deals' });
}

function navigateToRestaurants() {
  bus.emit('bottom_nav:navigation_required', { id: 'restaurants' });
}

function handleCategoryClicked(category) {
  bus.emit('search:by_category_requested', category);
}

// Lifecycle hooks
onMounted(() => {
  setTimeout(() => {
    showAll.value = true;
    console.log('[HomePage] showAll set to true');
  }, 1000);

  console.log('[HomePage] onMounted - Component mounted');
  console.log('[HomePage] Store available?', !!window.$stores?.home);
  console.log('[HomePage] Store state:', window.$stores?.home?.state);

  homeLoadEvents();
  savePageShowMarker();
  tryCategoriesOnboarding();

  // Load notifications to update unread badge
  bus.emit(constants.EVENTS.INBOX?.NOTIFICATIONS_LOAD);
});

onBeforeUnmount(() => {
  clearTimeout(categoryOnboardingTimeoutId);
});
</script>
